type IndexableObject = { [key: string]: any }

function isUnsafeKey(key: string): boolean {
  return key === '__proto__' || key === 'constructor' || key === 'prototype'
}

function deepSetObject(
  source: IndexableObject | null | undefined,
  keyString: string,
  value: unknown,
): IndexableObject | undefined {
  if (!keyString){
    return undefined
  }

  const updated: IndexableObject = source
    ? JSON.parse(JSON.stringify(source))
    : {}

  const keys = keyString.split('.')

  const lastKey = keys.pop()

  if (!lastKey || isUnsafeKey(lastKey) || keys.some(isUnsafeKey)){
    return undefined
  }

  const lastObject = keys.reduce((acc: IndexableObject, key: string) => {
    // Prevent creating properties with unsafe keys
    if (isUnsafeKey(key)){
      // Abort immediately on unsafe key
      throw new Error('Unsafe key detected in deepSetObject')
    }

    if (!acc[key] || typeof acc[key] !== 'object' || Array.isArray(acc[key])){
      acc[key] = {}
    }
    return acc[key]
  }, updated)

  lastObject[lastKey] = value

  return updated
}

export default deepSetObject
